import {
  useDeleteMutation,
  useGetQuery,
  useLazyGetQuery,
  usePutMutation,
} from "slices/api";
import { NOTIFICATION } from "tagTypes";

export const useNotificationQuery = (query = {}, options = {}) =>
  useGetQuery(
    {
      endpoint: "/notification",
      query,
      tags: [NOTIFICATION],
    },
    options
  );

export const useNotificationCountQuery = (options = {}, isFireSafety) =>
  useGetQuery(
    {
      endpoint: isFireSafety
        ? "/firesafety-notification/get-unread-notification-count"
        : "/notification/get-unread-notification-count",
      tags: [NOTIFICATION],
    },
    options
  );

export const useLazyNotificationQuery = (options = {}) => {
  const [getNotification, data] = useLazyGetQuery(options);
  const getNotifications = async (
    query = {},
    preferCachingValue = true,
    isFireSafety
  ) =>
    await getNotification(
      {
        endpoint: isFireSafety ? "firesafety-notification" : "/notification",
        query,
        tags: [NOTIFICATION],
      },
      preferCachingValue
    ).unwrap();
  return [getNotifications, data];
};

export const useDeleteNotificationMutation = () => {
  const [notificationStatus, data] = useDeleteMutation();
  const deleteNotifications = async (isFireSafety) =>
    await notificationStatus({
      endpoint: isFireSafety ? "firesafety-notification" : "/notification",
      toastMessage: "Notifications deleted successfully",
      tags: [NOTIFICATION],
    }).unwrap();
  return [deleteNotifications, data];
};

export const useUpdateNotificationMutation = () => {
  const [updateNotification, data] = usePutMutation();
  const updateNotificationState = async (payload, query = {}, isFireSafety) =>
    await updateNotification({
      endpoint: isFireSafety ? "firesafety-notification" : "/notification",
      query,
      payload: payload || {},
      tags: [NOTIFICATION],
    }).unwrap();
  return [updateNotificationState, data];
};
